// App name: Car Number Form
// Description:

const carNumberApp = (function ($) {

  // variables
  let _plate_form = $('.plate_form form.cart');
  let _plate_yithBlock = _plate_form.find('.yith-wapo-block');
  let _container   = $('.plate_form');
  let _display  = _container.find('input.plate_form--display-text');

  // init
  function init() {
    initPlate();
    initPlateDisplay();
    initPlateAddClass();
    initPlateChangeFontColor();
  }

  function initPlate() {
    setTimeout( function() {
      let _plateContainer   = $('.plate_form');
      let _namePlaceholder  = $('.yith-wapo-addon-type-text label').text().replace('*','').trim();

      if( _plateContainer.length > 0) {
        _plateContainer.find('select').attr('required', '');
      }

      $('.yith-wapo-addon-type-text input').attr('placeholder',_namePlaceholder);
      $('.yith-wapo-addon-type-text input').attr('maxlength','11');

      initSelectPlaceholder();

      // Handle event change icon flag
      let _wappenLink   = '#yith-wapo-5';
      let _wappenRecht   = '#yith-wapo-15';
      let _leftSide = $('.plate_form--display-icon.is-left');
      let _rightSide = $('.plate_form--display-icon.is-right');

      initPlateIcon(_wappenLink, _leftSide);
      initPlateIcon(_wappenRecht, _rightSide);
    }, 500);


  }

  function initSelectPlaceholder() {
    let _count = 0;

    $('.yith-wapo-addon-type-select').each(function() {

      if ( _count++ > 1 ) {
        let _text = $(this).find('.wapo-addon-title').text();
        $(this).find('select option').first().text(`${_text}`);
      } else {
        let _text = $(this).find('.wapo-addon-title').text();
        $(this).find('select option').first().text(`${_text}`);
      }

    });

    $('#yith-wapo-2 option').first().text('Schildfarbe / Schriftfarbe wählen');
  }

  function initPlateDisplay() {
    let _container   = $('.plate_form');
    let _nameField   = _container.find('.yith-wapo-addon-type-text input');
    let _nameDisplay = _container.find('input.plate_form--display-text');

    _nameField.on('keyup', function() {
      let _text = _nameField.val().slice(0, 11);

      if ( !_text.trim()) {
        _nameDisplay.val('');
      } else {
        _nameDisplay.val(_text);
      }
    });

    _nameDisplay.on('keyup paste', function() {
      let _text = _nameDisplay.val().substring(0, 11);

      if ( !_text.trim()) {
        _nameField.val('');
      } else {
        _nameField.val(_text);
      }
    });
  }

  function initPlateIcon(selectbox, iconPosition) {
    $(document).on('change', selectbox, function(e){
      e.preventDefault();

      let _data = $(this).find(":selected").text().trim();

      iconPosition.removeClass(function (index, css) {
        return (css.match (/\bicon-\S+/g) || []).join(''); // removes anything that starts with "is-"
      });
      iconPosition.addClass(`${'icon-'+_data}`);
    });
  }

  function initPlateAddClass() {
    let yith_select = _plate_yithBlock.find('.yith-wapo-addon-type-select');

    yith_select.each(function(e) {
      let _text = $(this).find('.wapo-addon-title').text().split(" ").join("").toLowerCase();
      $(this).addClass('select_'+_text);
    });
  }

  function initPlateChangeFontColor() {
    _plate_form.find('.yith-wapo-addon-type-select').first().addClass('select_plateColor');

    $(document).on('change', '.select_plateColor select', function(e) {
      let _data = $(this).find(":selected").text().trim();

      var text = _data.split(" ").join("").split("/");
          var font = text[1] || 'blau';
          var sign = text[0] || 'weiss';

          _display.removeClass(function (index, css) {
            return (css.match (/\bfont-\S+/g) || []).join(''); // removes anything that starts with "font-"
          });
          _display.removeClass(function (index, css) {
            return (css.match (/\bsign-\S+/g) || []).join(''); // removes anything that starts with "font-"
          });

          _display.addClass(`plate_form--display-text ${'font-'+font}`);
          _display.addClass(`plate_form--display-text ${'sign-'+sign}`);
    });
  }

  return {
      init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  carNumberApp.init();
});
